<template>
  <div class="consent-widget-wrapper">
    <app-button/>
    <app-modal/>
  </div>
</template>

<script>
  import AppButton from '@/components/widgets/consent/components/Button';
  import AppModal from '@/components/widgets/consent/components/Modal';

  export default {
    name: 'ConsentWidget',

    components: {
      AppButton, AppModal
    },
  }
</script>

<style scoped lang="scss">

</style>
